import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Send } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const BY_CLS = {
  client: "bg-emeraude/15 text-emeraude-dark",
  loueur: "bg-canard/15 text-canard-dark",
  admin: "bg-yellow-100 text-yellow-700",
};

export function ClaimThread({ messages = [], onSend, testid, quickReplies }) {
  const { t } = useTranslation();
  const [text, setText] = useState("");
  const send = () => { const v = text.trim(); if (!v) return; onSend(v); setText(""); };
  return (
    <div className="mt-2 pt-2 border-t border-border/60" data-testid={testid}>
      {messages.length > 0 && (
        <div className="space-y-1.5 mb-2">
          {messages.map((m, i) => (
            <div key={`${m.at}-${i}`} className="flex items-start gap-2">
              <span className={`text-[10px] font-bold px-1.5 py-0.5 rounded-full shrink-0 ${BY_CLS[m.by] || "bg-sand text-muted2"}`}>{t(`claims.by_${m.by}`)}</span>
              <p className="text-xs text-ink font-body break-words">{m.text}</p>
            </div>
          ))}
        </div>
      )}
      {quickReplies?.length > 0 && (
        <div className="flex flex-wrap gap-1.5 mb-2" data-testid={`${testid}-quick`}>
          {quickReplies.map((q) => (
            <button key={q.label} data-testid={`${testid}-qr`} onClick={() => onSend(q.text)}
              className="text-[10px] font-bold px-2 py-1 rounded-full bg-canard/10 text-canard-dark hover:bg-canard/20 transition-colors">{q.label}</button>
          ))}
        </div>
      )}
      <div className="flex gap-2">
        <Input data-testid={`${testid}-input`} value={text} onChange={(e) => setText(e.target.value)}
          onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); send(); } }}
          placeholder={t("claims.messagePh")} className="h-9 rounded-full bg-sand text-xs" />
        <Button size="sm" data-testid={`${testid}-send`} onClick={send} disabled={!text.trim()}
          className="rounded-full h-9 px-3 bg-canard hover:bg-canard-dark shrink-0"><Send className="w-3.5 h-3.5" /></Button>
      </div>
    </div>
  );
}
